module.exports = __webpack_public_path__ + "static/media/add_tag_shortened.679428d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/add_tag_shortened.gif
// module id = 518
// module chunks = 0